import React from 'react';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  MainTitle,
  SubtitleMain,
  ContactEmailAddress,
} from '../../utils/Constants';
import { CONTACT_PAGE_URL } from '../../utils/Routes';

function HomePageHeader() {
  return (
    <header className='grid px-4 sm:px-16 md:px-20 pt-6 lg:pt-36 z-10'>
      <div
        className='grid relative w-full h-full bg-dark bg-hero bg-cover bg-no-repeat min-h-[60vh] lg:min-h-[90vh] bg-center rounded-2xl shadow-cardShadowBold shadow-colour4/80 dark:shadow-colour4/80 '
        role='banner'
      >
        {/* Phone titles */}
        <div className='grid lg:hidden fade-opacity bg-black/40 opacity-50 curved_box p-1.5 rounded-lg text-center absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white'>
          <div className='grid p-0.5 rounded-lg bg-colour3 curved_box'>
            <div className='grid bg-colour2 rounded-lg curved_box px-6 py-4'>
              <span className='text_shadow text-3xl font-bold uppercase'>
                {CompanyName}
              </span>
              <div className='overflow-hidden text-center mt-2 bg-red-900/50 mx-2'>
                <a
                  href={`mailto:${ContactEmailAddress}`}
                  className='text-lg'
                  aria-label={`Email ${CompanyName} at ${ContactEmailAddress}`}
                >
                  <div>
                    <span className='font-semibold hidden md:inline-block '>Email: </span>
                    <p className='text-xs md:text-base lead px-4 rounded-sm'>
                      {ContactEmailAddress}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Main Header Section */}
        <article
          className='hidden lg:grid bg-colour2 mt-6 h-fit lg:absolute lg:left-[25vw] lg:transform lg:-translate-x-1/2 lg:-translate-y-1/2 lg:top-[60%] lg:bg-colour2/80 p-1.5 rounded-lg shadow-lg curved_box'
          aria-labelledby='header-title'
        >
          <div className='grid p-0.5 rounded-lg bg-colour3 curved_box'>
            <div className='grid px-10 py-6 bg-colour2 rounded-lg curved_box'>
              <div className='grid relative font-titleFont leading-4 gap-3 lg:gap-1 text-center text-colour1'>
                <h1
                  id='header-title'
                  className='text-3xl lg:text-4xl xl:text-5xl font-extrabold text__stroke uppercase'
                >
                  {CompanyName}
                </h1>
                <h2 className='text-lg font-semibold italic'>{MainTitle}</h2>
                <h3 className='py-1'>{SubtitleMain}</h3>
                <h4 className='py-1'>{CompanyTagLine}</h4>
                <div className='grid mt-2'>
                  <a
                    href={CONTACT_PAGE_URL}
                    title='Request a session now'
                    className='border-2 cursor-pointer border-solid py-2 px-6 rounded border-colour3 text-colour1 bg-colour4/80 duration-300 hover:bg-red-700 md:max-w-fit md:px-10 md:mx-auto'
                    aria-label='Request a session now'
                  >
                    <span className='uppercase font-bold'>Submit to Me</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </header>
  );
}

export default HomePageHeader;
